module.exports = __webpack_public_path__ + "static/media/cpg_mobile_instagram_video.b723c95d.png";